module.exports = __webpack_public_path__ + "img/sex-offenders.svg";